import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

export const PublicRoute = ({ children }) => {
  const { isAuth, loading } = useContext(AuthContext);
  const location = useLocation();
  if (loading) return <BackdropLoading />;
  if (isAuth) return <Navigate to="/dashboard" state={{ from: location }} replace />;
  return children;
};

// Paths that remain accessible even after trial expiry
const TRIAL_EXEMPT_PATHS = new Set(["/Settings", "/billing"]);

const PrivateRoute = ({ children, skipTrialCheck = false, requiredRole }) => {
  const { isAuth, loading, trialExpired, user } = useContext(AuthContext);
  const location = useLocation();
  if (loading) return <BackdropLoading />;
  if (!isAuth) return <Navigate to="/login" state={{ from: location }} replace />;
  if (requiredRole && user?.profile !== requiredRole) return <Navigate to="/dashboard" replace />;
  const exempt = skipTrialCheck || TRIAL_EXEMPT_PATHS.has(location.pathname) || user?.profile === "superadmin";
  if (!exempt && trialExpired) return <Navigate to="/trial-expired" replace />;
  return children;
};

export default PrivateRoute;
